import { t } from '@/i18n/utils'

/**
 * 消费记录页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const consumeCommonConfig = {
  texts: {
    /** 页面标题（NovelMello 顶栏常驻标题使用；其它品牌顶栏不展示标题，不受影响） */
    get pageTitle() { return t('ChaptersUnlocked') },
    get noRecord() { return t('NoConsumptionRecord') },
    get noMore() { return `${t('NoMore')} ~` },
    get loading() { return `${t('Loading')}...` },
    get coins() { return t('Coins') },
  },
}
